import type { Storage } from '../platform/storage'
import type { ChildProfile } from '../core/types'
import { KEY } from './keys'

/**
 * Профиль ребёнка. Значения хранятся строками: в Capacitor мост переводит их
 * в типы `SharedPreferences`, формат ключей от этого не меняется.
 */
export async function loadProfile(storage: Storage): Promise<ChildProfile | null> {
  const name = await storage.get(KEY.childName)
  const birth = await storage.get(KEY.childBirth)
  if (name === null || birth === null) return null
  const birthMillis = Number(birth)
  if (!Number.isFinite(birthMillis) || birthMillis <= 0) return null
  const weight = Number(await storage.get(KEY.childBirthWeight))
  return {
    name,
    birthMillis,
    gender: (await storage.get(KEY.childGender)) === 'GIRL' ? 'GIRL' : 'BOY',
    gasVariant: (await storage.get(KEY.gasVariant)) === 'true',
    ...(Number.isFinite(weight) && weight > 0 ? { birthWeightGrams: weight } : {}),
  }
}

export async function saveProfile(storage: Storage, profile: ChildProfile, now = Date.now()): Promise<void> {
  await storage.set(KEY.childName, profile.name)
  await storage.set(KEY.childBirth, String(profile.birthMillis))
  await storage.set(KEY.childGender, profile.gender)
  await storage.set(KEY.gasVariant, String(profile.gasVariant))
  if (profile.birthWeightGrams !== undefined && profile.birthWeightGrams > 0) await storage.set(KEY.childBirthWeight, String(profile.birthWeightGrams))
  else await storage.remove(KEY.childBirthWeight)
  await storage.set(KEY.profileUpdatedAt, String(now))
}

export async function profileUpdatedAt(storage: Storage): Promise<number> {
  return Number((await storage.get(KEY.profileUpdatedAt)) ?? 0)
}
